<template>
	<span class="nobr">{{ formattedDate }}</span>
</template>

<script>
import { computed, toRef } from 'vue'
import { datetimeToStringFormat } from '@/components/common/dateUtils';

export default {
	props: {
		date: {
			type: [Date, String, null],
			default: null,
		},
		format: {
			type: String,
			default: 'YYYY-MM-DD HH:mm',
		},
		hideUtc: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const dateRef = toRef(props, 'date');
		const formatRef = toRef(props, 'format');
		const hideUtcRef = toRef(props, 'hideUtc');
		const formattedDate = computed(() => {
			if (!dateRef.value) {
				return '—';
			}
			return datetimeToStringFormat(dateRef.value, formatRef.value) + (hideUtcRef.value ? '' : ' UTC');
		});
		return {
			formattedDate,
		};
	},
}
</script> 